import React, { useState } from 'react';
import { WelcomeOfferStyled } from './WelcomeOffersStyled';
import { IC_COPY_IMAGE, IC_TICK } from '../../../public/images';
import Image from 'next/dist/client/image';
import { ToastControl } from '@common/Component/Forms';
import { useTranslation } from '@common/i18n';

const WelcomeOffer = ({ cmsResult }) => {
    const {
        iconImage,
        backgroundImageWeb,
        couponCode,
        name,
        description,
    } = cmsResult;

    const t = useTranslation();

    const [showToast, setShowToast] = useState(false);

    const getItemNames = (itemNames) => {
        if (itemNames?.length >= 7) {
            return `${itemNames?.substring(0, 6)}...`;
        }
        return itemNames;
      };



    const copyToClipboard = () => {
        const el = document.createElement('textarea');
        el.value = couponCode;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 3000);

    };

    const modifieddescription = description?.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    return (
        <>
            <WelcomeOfferStyled
                style={{
                    background: `url(${backgroundImageWeb}) left no-repeat, linear-gradient(to right, #F4FFF0, #FEFEFF)`,
                    backgroundSize: 'contain',
                    border: '1px solid #C9EFCB',
                    borderRadius: '10px',
                }}
            >
                <div className="left-content">
                    <img
                        src={iconImage}
                        alt={'image'}
                        className="image-style"
                    />
                    <div className="title-subtitle-container">
                        <div className="title-above-subtitle">{name}</div>
                        <div
                            className="subtitle"
                            dangerouslySetInnerHTML={{ __html: modifieddescription }}
                        ></div>
                    </div>
                </div>
                <div className="promo-code" onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
                    <span className="promo-code-text">{getItemNames(couponCode)}</span>
                    <Image src={IC_COPY_IMAGE} className="copy-image" alt="Copy Icon" />
                </div>
            </WelcomeOfferStyled>
            {showToast && (
                <ToastControl
                    className={`${scrollY > 38 ? 'toast-fixed ' : ''}`}
                    text={t('EPharmacyCheckout.copiedText')}
                    variant="green-dark-box justify-content-top-left floating-wrapper toast-image"
                    imgBox={true}
                    imgError={IC_TICK}
                />
             )}
        </>
    );
};

export default WelcomeOffer;
